import { AlertConfirmationTypes } from "../../../../../helpers/constant";
import { calculateAgeYear } from "../../../../../helpers/functions";
import ComingSoon from "../../../../common/tooltip/medication-review/coming-soon";
import PatientAck from "../../../../common/tooltip/medication-review/patient-ack";
import PharmaWorksheet from "../../../../common/tooltip/medication-review/pharma-worksheet";
import DocumentationForBillingNote from "../../../../common/tooltip/minor-ailments/Doc-for-billing-note";

export const consultedSources = [
  {
    label: "Pharmacy Profile",
  },
  {
    label: "Physician",
  },
  {
    label: "Nurse Practitioner",
  },
  {
    label: "Patient",
  },
  {
    label: "Caregiver/ Agent/ Family",
  },
  {
    label: "Medication Packages/ Compliance or Blister Package",
  },
  {
    label: "Laboratory/ Test Values",
  },
  {
    label: "Medication Record from another Pharmacy",
  },
  {
    label: "Electronic Health Record",
  },
  {
    label: "Hospital/ Other Facility",
  },
];

export const checklist = [
  {
    label:
      "Asked about Rx Medications from other individuals, MD samples, pharmacies and care providers",
  },
  {
    label: "Medications removed from home by the Pharmacist (if applicable)",
  },
  {
    label: "Asked about OTC products (including ASA)",
  },
  {
    label: "Asked about herbal or natural health products ",
  },
  {
    label:
      "Prompted for Miscellaneous medications (ie/inhalers, topicals, eye drops, nasal sprays, patches, injectables, cannabis products)",
  },
  {
    label: "Asked about anti-infectives used in the last 3 months",
  },
  {
    label: "Referenced attached notes, results, references as appropriate",
  },
  {
    label:
      "Discussed circle of care, sharing information with other providers and the patient’s responsibility for providing accurate information (Included in Consent Form)",
  },
  {
    label:
      "Discussed anticipated date of completion of patient’s MedsCheck Personal Medication Record (if not available at the time of the MedsCheck) (Included in Consent Form)",
  },
  {
    label:
      "Ensure clinically relevant information is documented and readily retrievable for continuity of care and for audit purposes",
  },
  {
    label: "Other (Specify)",
  },
];

export const DocumentTitles = {
  PatientForms: "Patient Forms",
  PharmacistForms: "Pharmacist Forms",
  PrimaryProviderForms: "Primary Provider Forms",
};

export const MedicationReviewDocTypes = {
  PersonalMedRecord: "personal-medication-record",
  StoryBoard: "take-home-summary",
  Notepad: "notepad-amr",
  NotepadPharmacist: "notepad-pharmacist-amr",
  NotepadPatient: "notepad-patient-amr",
  PharmacistWorksheet: "pharmacists-worksheet",
  PatientAcknowledgement: "patient-acknowledgement",
  ProviderNotification: "health-care-provider-notification",
};

export const MedicationReviewForms = [
  {
    id: 1,
    title: DocumentTitles.PatientForms,
    iconUrl: "/icons/patient-square.svg",
    forms: [],
  },
  {
    id: 2,
    title: DocumentTitles.PharmacistForms,
    iconUrl: "/icons/pharmacist-square.svg",
    forms: [],
  },
  {
    id: 3,
    title: DocumentTitles.PrimaryProviderForms,
    iconUrl: "/icons/physician-square.svg",
    forms: [],
  },
];

export const ListOfAMRForms = [
  // Patient Forms
  {
    id: 1,
    name: "Personal Medication Record",
    isTooltip: false,
    tooltipComponent: null,
    filePath: null,
    type: MedicationReviewDocTypes.PersonalMedRecord,
    sectionKey: DocumentTitles.PatientForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/AMR/MedicationRecordInActive.svg",
    activeIcon: "/icons/medicalSummary/AMR/MedicationRecordActive.svg",
  },
  {
    id: 2,
    name: "Storyboard",
    isTooltip: true,
    tooltipComponent: ComingSoon,
    filePath: null,
    type: MedicationReviewDocTypes.TakeAwaySummary,
    sectionKey: DocumentTitles.PatientForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/AMR/StoryBoardInActive.svg",
    activeIcon: "/icons/medicalSummary/AMR/StoryBoardActive.svg",
  },
  {
    id: 1,
    name: "Pharmacist's Worksheet",
    isTooltip: true,
    tooltipComponent: PharmaWorksheet,
    filePath: null,
    type: MedicationReviewDocTypes.PharmacistWorksheet,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/AMR/PharmacistWorksheetInActive.svg",
    activeIcon: "/icons/medicalSummary/AMR/PharmacistWorksheetActive.svg",
  },
  {
    id: 3,
    name: "Patient Acknowledgement of Pharmacy Services",
    isTooltip: true,
    tooltipComponent: PatientAck,
    filePath: null,
    type: MedicationReviewDocTypes.PatientAcknowledgement,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/AMR/ConsentInActive.svg",
    activeIcon: "/icons/medicalSummary/AMR/ConsentActive.svg",
  },
  {
    id: 1,
    name: "Health Care Provider Notification of MedsCheck Services",
    isTooltip: false,
    tooltipComponent: null,
    filePath: null,
    type: MedicationReviewDocTypes.ProviderNotification,
    sectionKey: DocumentTitles.PrimaryProviderForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/AMR/HealthcareProviderInActive.svg",
    activeIcon: "/icons/medicalSummary/AMR/HealthcareProviderActive.svg",
  },
  {
    id: 1,
    name: "Personal Medication Record",
    isTooltip: false,
    tooltipComponent: null,
    filePath: null,
    type: MedicationReviewDocTypes.PersonalMedRecord,
    sectionKey: DocumentTitles.PrimaryProviderForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/AMR/MedicationRecordInActive.svg",
    activeIcon: "/icons/medicalSummary/AMR/MedicationRecordActive.svg",
  },
  {
    //if have prescriptions and to fill all not just 1 at alternate location || if i end a service
    id: 10,
    name: "Notepad",
    isTooltip: false,
    tooltipComponent: null,
    filePath: null,
    type: MedicationReviewDocTypes.Notepad,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/NotesInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/NotesActive.svg",
  },
];

export function getFormByDocType(docType) {
  return allForms.find((form) => form.type === docType) || null;
}

export const AllergicRhinitisForms = [
  {
    id: 1,
    title: DocumentTitles.PatientForms,
    iconUrl: "/icons/patient-square.svg",
    forms: [],
    isTooltip: true,
  },
  {
    id: 2,
    title: DocumentTitles.PharmacistForms,
    iconUrl: "/icons/pharmacist-square.svg",
    forms: [],
  },
  {
    id: 3,
    title: DocumentTitles.PrimaryProviderForms,
    iconUrl: "/icons/physician-square.svg",
    forms: [],
  },
];

export const AllergicRhinitisDocTypes = {
  //CR
  Storyboard: "allergic-rhinitis-storyboard",
  //CR if any prescriptions
  Prescription: "prescription",
  //end service
  PatientReferral: "patient-referral",
  InitialAssessment: "initial-assessment",
  FollowUpAssessment: "follow-up-assessment",
  Notepad: "notepad",
  NotepadPharmacist: "notepad-pharmacist-ma",
  NotepadPatient: "notepad-patient-ma",
  //all alternate location || end a service
  CommunicationForBilling: "communication-for-billing",
  //CNR
  PrescribingRecord: "prescribing-record",
  //CR
  PrescribingRecordWithReferral: "prescribing-record-referral",
  //end service
  PhysicianReferralForm: "physician-referral-form",
};

// 2. Flat list of all AR forms
export const ListOfForms = [
  // Patient Forms
  {
    id: 1,
    name: "Storyboard",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.Storyboard,
    sectionKey: DocumentTitles.PatientForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/StoryBoardInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/StoryBoardActive.svg",
  },
  {
    id: 2,
    name: "Prescriptions",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.Prescription,
    sectionKey: DocumentTitles.PatientForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/PrescriptionsIssuedInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/PrescriptionsIssuedActive.svg",
  },
  {
    id: 3,
    name: "Patient Referral",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.PatientReferral,
    sectionKey: DocumentTitles.PatientForms,
    enable: false,
    inActiveIcon: "/icons/medicalSummary/MA/PatientReferalFormInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/PatientReferalFormActive.svg",
  },

  // Pharmacist Forms
  {
    //show always
    id: 4,
    name: "Pharmacist Initial Assessment",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.InitialAssessment,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon: "/icons/medicalSummary/MA/PharmistInitialAssesmentInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/PharmistInitialAssesmentActive.svg",
  },
  {
    //show never
    id: 5,
    name: "Follow-Up Assessment",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.FollowUpAssessment,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/FollowUpInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/FollowUpActive.svg",
  },
  {
    //if have prescriptions and to fill all not just 1 at alternate location || if i end a service
    id: 6,
    name: "Documentation for Billing",
    isTooltip: true,
    tooltipComponent: DocumentationForBillingNote,
    type: AllergicRhinitisDocTypes.CommunicationForBilling,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/CommunicationForBillingInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/CommunicationForBillingActive.svg",
  },
  {
    //if have prescriptions and to fill all not just 1 at alternate location || if i end a service
    id: 10,
    name: "Notepad",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.Notepad,
    sectionKey: DocumentTitles.PharmacistForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/NotesInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/NotesActive.svg",
  },

  // Physician Forms
  {
    //if i say continue with no referral
    id: 7,
    name: "Pharmacist Prescribing Record",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.PrescribingRecord,
    sectionKey: DocumentTitles.PrimaryProviderForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/PharmacistPrescribingRecordInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/PharmacistPrescribingRecordActive.svg",
  },
  {
    //if i say continue with referral
    id: 8,
    name: "Pharmacist Prescribing Record + Referral",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.PrescribingRecordWithReferral,
    sectionKey: DocumentTitles.PrimaryProviderForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/PharmacistPrescribingRecordReferralInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/PharmacistPrescribingRecordReferralActive.svg",
  },
  {
    //if end service
    id: 9,
    name: "Primary Provider Referral Form",
    isTooltip: false,
    tooltipComponent: null,
    type: AllergicRhinitisDocTypes.PhysicianReferralForm,
    sectionKey: DocumentTitles.PrimaryProviderForms,
    enable: false,
    inActiveIcon:
      "/icons/medicalSummary/MA/PhysicianReferalFormInActive.svg",
    activeIcon: "/icons/medicalSummary/MA/PhysicianReferalFormActive.svg",
  },
];
// inActiveIcon: "/icons/medicalSummary/NotesInActive.svg",
// activeIcon: "/icons/medicalSummary/NotesActive.svg",

export const getAllConfirmationTypes = (serviceObj) => [
  serviceObj?.preAssessment?.ageAlertConfirmationType,
  serviceObj?.preAssessment?.pregnancyAlertConfirmationType,
  serviceObj?.clinicalAssessment?.redFlagConfirmationType,
  serviceObj?.clinicalAssessment?.drugInducedConfirmationType,
  serviceObj?.signsAndSymptoms?.nonTypicalConfirmationType,
  serviceObj?.signsAndSymptoms?.typicalConfirmationType,
  serviceObj?.signsAndSymptoms?.allergensConfirmationType,
  serviceObj?.signsAndSymptoms?.infectiveConfirmationType,
  serviceObj?.differentialAssessment?.differentialConfirmationType,
  serviceObj?.treatment?.pharmacologicalHistoryConfirmationType,
  serviceObj?.treatment?.pharmacologicalConfirmationType,
];

export const GetReferralDetails = (serviceObj) => {
  const types = getAllConfirmationTypes(serviceObj);

  return {
    NoConfirmationAlert: types.every((type) => type === 0 || type == null),
    ContinueWithReferral: types.includes(
      AlertConfirmationTypes.ContinueWithRefer
    ),
    ContinueWithNoReferral: types.includes(
      AlertConfirmationTypes.ContinueWithNoReferral
    ),
    EndServiceAndRefer: types.includes(AlertConfirmationTypes.EndService),
    OTCConsultAndRefer: types.includes(AlertConfirmationTypes.OTCConsult),
  };
};

const normalizeLocation = (location) => {
  if (location == null) return "";
  return String(location).trim().toLowerCase();
};

const isAlternatePharmacyLocation = (location) => {
  const normalized = normalizeLocation(location);
  return normalized === "alternate" || normalized === "alternate pharmacy";
};

/** MA completion modal writes `treatmentPharmacyLocations` before treatment refetch. */
const getSessionTreatmentPharmacyLocationMap = () => {
  try {
    const raw = JSON.parse(
      sessionStorage.getItem("treatmentPharmacyLocations") || "null"
    );
    return raw != null && typeof raw === "object" ? raw : null;
  } catch {
    return null;
  }
};

const getSessionPharmacyLocationForDrug = (map, drug) => {
  if (!map) return undefined;
  for (const k of [drug?.id, drug?.medicationId]) {
    if (k == null || k === "") continue;
    if (Object.prototype.hasOwnProperty.call(map, k)) return map[k];
    const sk = String(k);
    if (Object.prototype.hasOwnProperty.call(map, sk)) return map[sk];
  }
  return undefined;
};

export const checkFormEnable = (
  formType,
  alertData,
  prescriptionDrugs,
  dateOfBirth,
  documentation = null
) => {
  const sessionPharmacyMap = getSessionTreatmentPharmacyLocationMap();
  const hasAlternatePharmacyPrescription =
    Array.isArray(prescriptionDrugs) &&
    prescriptionDrugs.some((drug) => {
      const sessionLocation = getSessionPharmacyLocationForDrug(sessionPharmacyMap, drug);
      const loc =
        sessionLocation != null && String(sessionLocation).trim() !== ""
          ? sessionLocation
          : drug?.pharmacyLocation ?? drug?.pharmacy?.location;
      return isAlternatePharmacyLocation(loc);
    });
  const hasAlternatePharmacyInDocumentation = isAlternatePharmacyLocation(
    documentation?.pharmacyLocation
  );
  let referralWithNoEndService =
    alertData.ContinueWithReferral && !alertData.EndServiceAndRefer;
  let noReferralWithNoEndService =
    alertData.ContinueWithNoReferral && !alertData.EndServiceAndRefer;
  let neverFaceConfirmationAlert = alertData.NoConfirmationAlert;

  switch (formType) {
    case AllergicRhinitisDocTypes.Storyboard:
      return !alertData.EndServiceAndRefer;
    case AllergicRhinitisDocTypes.Prescription:
      return (alertData && alertData.EndServiceAndRefer) || (prescriptionDrugs && prescriptionDrugs.length > 0);
    case AllergicRhinitisDocTypes.PatientReferral:
      return alertData.EndServiceAndRefer;
    case AllergicRhinitisDocTypes.InitialAssessment:
      return true;
    case AllergicRhinitisDocTypes.FollowUpAssessment:
      return false;
    case AllergicRhinitisDocTypes.CommunicationForBilling: {
      const hasAlternateSelection = hasAlternatePharmacyPrescription || hasAlternatePharmacyInDocumentation;
      const isContinueFlow = referralWithNoEndService || noReferralWithNoEndService;
      if (isContinueFlow && !hasAlternateSelection) {
        return false;
      }
      return (
        Boolean(alertData?.EndServiceAndRefer) || hasAlternateSelection
      );
    }
    case AllergicRhinitisDocTypes.PrescribingRecord:
      return alertData.ContinueWithNoReferral && !alertData.ContinueWithReferral && !alertData.EndServiceAndRefer;
    case AllergicRhinitisDocTypes.PrescribingRecordWithReferral:
      return alertData.ContinueWithReferral && !alertData.EndServiceAndRefer;
    case AllergicRhinitisDocTypes.PhysicianReferralForm:
      return alertData.EndServiceAndRefer;
    case AllergicRhinitisDocTypes.Notepad:
      return true;
    default:
      return false;
  }
};

export const checkAMRFormEnable = (formType, noIntervention) => {
  switch (formType) {
    case MedicationReviewDocTypes.PersonalMedRecord:
      return noIntervention;
    default:
      return true;
  }
};

export const PrimaryProviderRuleTooltipsSelected = {
  [AllergicRhinitisDocTypes.PrescribingRecord]:
    "Generated when service is complete without a referral.",

  [AllergicRhinitisDocTypes.PrescribingRecordWithReferral]:
    "Generated only when a referral is recommended during the service.",

  [AllergicRhinitisDocTypes.PhysicianReferralForm]:
    "Service has ended, referral is required.",
};

export const PrimaryProviderRuleTooltipsDisabled = {
  [AllergicRhinitisDocTypes.PrescribingRecord]:
    "This form becomes available when service is complete without a referral",

  [AllergicRhinitisDocTypes.PrescribingRecordWithReferral]:
    "This form becomes available when a referral is recommended during the service.",

  [AllergicRhinitisDocTypes.PhysicianReferralForm]:
    "Service has ended, referral is required.",
};

